import React, { type FC } from 'react'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '../ui/Typography'
import { colors } from '../styles/colors'
import Attention from '../svgr/Attention'
import { DialogContainer } from './common.styles'

export const WithdrawalInProgressDialog: FC = () => {
  return (
    <DialogContainer>
      <IconContainer>
        <Attention />
      </IconContainer>

      <ContentContainer>
        <TitleContainer>
          <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
            <FormattedMessage
              id="dialog.withdrawalInProgress.title"
              defaultMessage="Вывод уже выполняется"
            />
          </Typography>
        </TitleContainer>

        <DescriptionContainer>
          <Typography fontSize={14} fontWeight={400} color={colors.secondary}>
            <FormattedMessage
              id="dialog.withdrawalInProgress.description"
              defaultMessage="У вас уже есть активная заявка на вывод. Пожалуйста, дождитесь её завершения."
            />
          </Typography>
        </DescriptionContainer>
      </ContentContainer>
    </DialogContainer>
  )
}

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 120px;
    height: auto;
  }
`

const ContentContainer = styled.div`
  display: grid;
  gap: 8px;
  max-width: 300px;
`

const TitleContainer = styled.div`
  text-align: center;
`

const DescriptionContainer = styled.div`
  text-align: center;
  line-height: 1.5;
`
